import { useState } from "react";
import { auth, errMessage } from "../api/client";
import { updateCachedUser, useCurrentUser } from "../lib/auth";

/**
 * Unumgehbares Datenschutz-Gate: sobald ein eingeloggter Nutzer geladen ist
 * und noch nie zugestimmt hat (privacy_accepted_at == null), liegt dieser
 * Vollbild-Blocker über der App — egal ob Web, Android, OIDC-Erstlogin oder
 * Bestandsnutzer. Der Zeitstempel landet als DSGVO-Nachweis in der DB.
 */
export default function PrivacyGate() {
  const user = useCurrentUser();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (!user || user.privacy_accepted_at) return null;

  async function accept() {
    setBusy(true);
    setErr(null);
    try {
      const updated = await auth.acceptPrivacy();
      updateCachedUser(updated);
    } catch (e) {
      setErr(errMessage(e));
      setBusy(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[70] grid place-items-center bg-ink-950/95 backdrop-blur-sm px-4">
      <div className="card p-6 w-full max-w-md space-y-4">
        <h2 className="section-title">Kurz bestätigen</h2>
        <p className="text-sm text-ink-300 leading-relaxed">
          Damit du Logbuch nutzen kannst, brauchen wir einmalig deine
          Zustimmung zur Datenschutzerklärung — dort steht genau, welche Daten
          wir wie verarbeiten (Server-Standort Schwerin, keine Weitergabe).
        </p>
        <label className="flex items-start gap-3 cursor-pointer select-none">
          <input
            type="checkbox"
            className="mt-0.5 h-4 w-4 shrink-0 accent-brand-500"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <span className="text-sm text-ink-200 leading-snug">
            Ich stimme der{" "}
            <a
              href="https://uselogbuch.de/datenschutz"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-brand-300 hover:text-brand-200"
            >
              Datenschutzerklärung
            </a>{" "}
            zu.
          </span>
        </label>
        {err && <p className="text-sm text-bad-500">{err}</p>}
        <button
          type="button"
          onClick={accept}
          disabled={!checked || busy}
          className="btn-primary w-full disabled:opacity-50"
        >
          {busy ? "Speichere …" : "Weiter"}
        </button>
      </div>
    </div>
  );
}
